/* global Promise */

import React from 'react';
import PropTypes from 'prop-types';

import styles from './QTIAssessmentItem.scss';

class QuestionInErrorState extends React.PureComponent {
    static propTypes = {
        question: PropTypes.object.isRequired,
        services: PropTypes.object.isRequired,
    };

    render() {
        const { question, services } = this.props;
        const { translationService } = services;

        const errorMessage = translationService.t('question.render.questionDamagedError', {
            questionTitle: question.title,
        });
        return (
            <div className={styles.QTIAssessmentItemError} dangerouslySetInnerHTML={{ __html: errorMessage }} />
        );
    }
}

export default QuestionInErrorState;
